define('collection-forms',['controller', 'dialogs', 'button-disabler', 'tooltip-notifier'],
        function(controller, dialogs, buttonDisabler, tooltipNotifier) {

    function openSettingsDialog(button) {
        var dialog = dialogs.openURL('/collections/' + button.data('collection-id') +'/edit');
        dialog.addClass('collection-form-dialog');

        buttonDisabler.disableUntilDone(button, dialog.opened);

        dialog.on('submitFormResponse', function(e, status, data) {
            if (status == 200) {
                window.location.href = data.url;
            }
        });
    }

    function openCreateFormDialog(button) {
        var dialog = dialogs.openURL('/collections/add');
        dialog.addClass('collection-form-dialog');

        buttonDisabler.disableUntilDone(button, dialog.opened);

        dialog.on('submitFormResponse', function(e, status, data) {
            if (status == 200) {
                window.location.href = data.url;
            }
        });
    }

    controller.on(['collections/view', 'users/collections'], function() {
        $('#show-collection-settings-button').click(function() {
            openSettingsDialog($(this));
        });

        $('body').on('click', '.show-confirm-delete-box', function(e) {
            e.preventDefault();
            $('.confirm-delete-box').show();
        });

        $('#show-collection-create-form').click(function() {
            openCreateFormDialog($(this));
        })
    });

    controller.on(['collections/view'], function() {
        $('.js-collection-contents .remove-post-button').click(function() {
            var collectionID = $(this).closest('.js-collection-contents').data('collectionId');
            var postID = $(this).data('id');
            var button = $(this);

            $.ajax({
                url: '/collections/' + collectionID + '/remove_post?post=' + postID,
                type: 'POST',
                dataType: 'json'
            }).done(function(data) {
                button.closest('.post-preview-removable-wrap').remove();
            }).fail(function(xhr) {
                tooltipNotifier.showError(button, 'Fehler', xhr);
            });
        });
    });
});


